import { createApp } from "vue";
import BaseLayout from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./tailwind.css";
import axiosPlugin from "./helpers/axios-plugin.js";
import { moneyMixin } from "./helpers/moneyMixin";
import slugifyPlugin from "./helpers/slugifyPlugin";
import truncatePlugin from "./helpers/textTruncate";
import getInitialsPlugin from "./helpers/GetInitialsPlugin";

createApp(BaseLayout)
  .use(store)
  .use(router)
  .mixin(moneyMixin)
  .use(slugifyPlugin)
  .use(getInitialsPlugin)
  .use(truncatePlugin)
  .use(axiosPlugin)
  .mount("#baselayout");
